export default __webpack_public_path__ + "e055da5b613066c58fa8e46ec04854e2.svg";